import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

import { apiGet } from '../common/apiTools';

export async function fetchPublicPortalURL(): Promise<string> {
  return apiGet<string>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/public-portal-url`);
}
